// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h7lQ","colBig":"styles_colBig__gGpEc","colSmall":"styles_colSmall__13JTH"};